// AGC: LegacyMainMenuAdapter — Bridge component for un-migrated screens
// AGC: Renders the old MainMenu in content-only mode (no shell — shell is provided by MainLayout)
// AGC: Reads the current URL path and maps it to MainMenu's activePage
// AGC: This component shrinks as screens are extracted to proper routes in Phase 2
import React from 'react'
import { useLocation } from 'react-router-dom'
import { MainMenu } from '../MainMenu'
import { pathToScreen } from '../../hooks/useAppNavigate'
import type { Screen } from '../../types'

export const LegacyMainMenuAdapter: React.FC = () => {
  const location = useLocation()
  // AGC: Map the current URL path to a MainMenu screen name
  const initialPage = pathToScreen(location.pathname) as Screen
  // AGC: Pass route state as initial nav context (memberId, plotId, etc.)
  const navState = (location.state as Record<string, any>) || undefined
  return <MainMenu contentOnly initialPage={initialPage} initialNavContext={navState} />
}
